// @ts-check

import gsap from 'gsap';
import { onDomReady } from '../utils/dom';
import { Browser } from '../utils/browsercheck';

(function () {
    /** @type {Draggable[]|null} */
    let instances = null;

    let drag = null;

    async function initDraggableContainer() {
        const kill = () => {
            instances?.forEach((instance) => instance.kill());
            instances = null;
        };

        if (Browser.isTouchDevice()) {
            kill();

            return;
        }

        const breadcrumb = document.querySelector('.mod_breadcrumb');
        const list = breadcrumb?.querySelector('ul');

        if (!breadcrumb || !list || breadcrumb.clientWidth === breadcrumb.scrollWidth) {
            kill();

            return;
        }

        if (drag === null) {
            drag = await import('gsap/Draggable');
            gsap.registerPlugin(drag.Draggable);
        }

        // Create the draggable element
        instances ??= drag.Draggable.create(breadcrumb, {
            type: 'scrollLeft',
            bounds: breadcrumb,
            allowContextMenu: true,
            onDragEnd() {
                if (Math.abs(this.deltaX) < 2) {
                    return;
                }

                let finalX = this.x + this.deltaX * 20;

                if (finalX < this.minX) {
                    finalX = this.minX;
                } else if (finalX > 0) {
                    finalX = 0;
                }

                gsap.to(breadcrumb, { scrollLeft: -finalX });
            },
        });
    }

    onDomReady(() => {
        initDraggableContainer();
    });

    window.addEventListener('resize', () => {
        initDraggableContainer();
    });
})();
